(function () {
  function updateSticky() {
    var headerWrap = document.querySelector('header#header');
    var topRow = document.querySelector('.header.header-2-lines .header-top');
    var menuRow = document.querySelector('.header.header-2-lines .navigationMenu');
    if (!headerWrap || !topRow || !menuRow) return;

    // Theme adds sticky-header class to rows on scroll
    var isSticky =
      topRow.classList.contains('sticky-header') ||
      menuRow.classList.contains('sticky-header');

    // Toggle one single sticky class on the whole header
    headerWrap.classList.toggle('is-sticky', isSticky);

    // Reserve exact height to avoid content jumping under fixed header
    if (isSticky) {
      var h = headerWrap.offsetHeight || 0;
      document.body.style.paddingTop = h + 'px';
    } else {
      document.body.style.paddingTop = '';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
  });
})();
/* =========================================================
   ADD ONLY: Vertical menu stable HOVER (works with lazy-load)
   ========================================================= */
(function () {
  function getList() {
    return document.querySelector("header#header .vertical_menu .list-vertical_menu");
  }

  function getTopLi(el) {
    return el && el.closest ? el.closest(".list-vertical_menu > ul > li") : null;
  }

  function hasSubmenu(li) {
    return !!(li && li.querySelector && li.querySelector(":scope > .subverticalmenu"));
  }

  function closeAll(list) {
    if (!list) return;
    list.querySelectorAll(":scope > ul > li.is-open").forEach(function (li) {
      li.classList.remove("is-open");
    });
  }

  var closeTimer = null;
  function clearClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }
  function scheduleClose(list) {
    clearClose();
    closeTimer = setTimeout(function () {
      closeAll(list);
    }, 120);
  }

  function bindDelegatedHover() {
    var list = getList();
    if (!list || list.dataset.vHoverBound === "1") return;
    list.dataset.vHoverBound = "1";

    // OPEN on hover (delegated, so it works after lazy-load inserts <li>)
    list.addEventListener("mouseover", function (e) {
      if (document.body.classList.contains("is-scrolling")) return;

      var li = getTopLi(e.target);
      if (!li || !hasSubmenu(li)) return;

      clearClose();

      // Open only current
      closeAll(list);
      li.classList.add("is-open");
    });

    // CLOSE when leaving list area
    list.addEventListener("mouseout", function (e) {
      // if moving within the list/submenu, ignore
      if (list.contains(e.relatedTarget)) return;
      scheduleClose(list);
    });

    // Keep open while inside submenu
    list.addEventListener("mouseenter", function () {
      clearClose();
    });
    list.addEventListener("mouseleave", function () {
      scheduleClose(list);
    });

    // Click outside closes
    document.addEventListener("click", function (e) {
      if (e.target.closest("header#header .vertical_menu")) return;
      closeAll(getList());
    });
  }

  // scroll state (prevents hover switching while scrolling)
  var t;
  function onScroll() {
    document.body.classList.add("is-scrolling");
    clearTimeout(t);
    t = setTimeout(function () {
      document.body.classList.remove("is-scrolling");
    }, 220);
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindDelegatedHover();
    window.addEventListener("wheel", onScroll, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("touchmove", onScroll, { passive: true });
  });

  // Back button restore
  window.addEventListener("pageshow", function () {
    bindDelegatedHover();
    closeAll(getList());
  });
})();
